import React, {memo} from 'react';
import ReactPlayer from 'react-player-linkorn-ruvideo';
import ClampLines from 'react-clamp-lines';

interface IMarketingMat {
  no?: number;
  name: string;
  description?: string;
  link?: string;
  mark_mat_order?: number;
}

interface IProps {
  id: IMarketingMat['no'];
  url?: IMarketingMat['link'];
  name: IMarketingMat['name'];
  description?: IMarketingMat['description'];
  controls?: boolean;
  playing?: boolean;
  width?: string;
  height?: string;
}

const MarketingMatItem: React.FC<IProps> = props => {
  const {
    id,
    name,
    url,
    description,
    controls,
    playing,
    width,
    height,
  } = props;

  return (
    <div className="card cards marketing-mat__wrap marketing-mat">
        <div className="marketing-mat__title-wrap">
          <span className="marketing-mat__title">{name}</span>
        </div>
        {description || !url
          ? (
            <div className="marketing-mat__content-wrap">
              <ClampLines
                id={`${id}`}
                text={description as string}
                lines={8}
                buttons={false}
                stopPropagation
                ellipsis="..."
                innerElement="p"
              />
            </div>
          )
          : (
            <ReactPlayer
              className="marketing-mat__player"
              url={url}
              controls={controls}
              playing={playing}
              width={width}
              height={height}
            />
          )
        }
    </div>
  );
};

MarketingMatItem.defaultProps = {
  url: '',
  controls: true,
  playing: false,
  width: '100%',
  height: '100%',
};

export default memo(MarketingMatItem);
